"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _consts = require("./consts");
var FileUtil = _interopRequireWildcard(require("./file"));
var _https = _interopRequireDefault(require("./https"));
var TaskUtil = _interopRequireWildcard(require("./task"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * OSS upload
 */
var Oss = /*#__PURE__*/function () {
  /**
   * @param config - The sdk config options
   */
  function Oss() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck2["default"])(this, Oss);
    var requestThread = config.requestThread,
      fileChunkSize = config.fileChunkSize;
    this.queue = [];
    this.availableThread = requestThread || _consts.DEFAULT_HTTP_CONNECTION_LIMIT;
    this.fileChunkSize = fileChunkSize;
    this.httpService = (0, _https["default"])(config);
  }

  /**
   * Decrease worker count
   */
  return (0, _createClass2["default"])(Oss, [{
    key: "consumeWorker",
    value: function consumeWorker() {
      --this.availableThread;
    }

    /**
     * Increase worker count
     */
  }, {
    key: "releaseWorker",
    value: function releaseWorker() {
      ++this.availableThread;
    }

    /**
     * Check if there is available worker
     */
  }, {
    key: "hasAvailableWorker",
    value: function hasAvailableWorker() {
      return this.availableThread > 0;
    }

    /**
     * Update upload queue
     */
  }, {
    key: "updateQueue",
    value: function updateQueue(data) {
      FileUtil.updateQueue(this.queue, data);
    }

    /**
     * Setup basic upload option to trigger file upload
     */
  }, {
    key: "upload",
    value: function upload(input, options) {
      var _this = this;
      return new Promise(function (resolve, reject) {
        var handleFailure = function handleFailure(error) {
          return reject(error);
        };
        options.onSuccess = function (res) {
          return resolve(res);
        };
        options.onFailure = handleFailure;
        options.onAbort = handleFailure;
        _this.uploadFile(input, options);
      });
    }

    /**
     * Push file to upload queue and start the worker
     */
  }, {
    key: "uploadFile",
    value: function uploadFile(input, options) {
      var filesize = FileUtil.getFileSize(input, options.filesize);
      var normalizedFile = FileUtil.normalizeFile({
        file: input,
        size: filesize,
        objectId: options.objectId,
        fileChunkSize: options.fileChunkSize || this.fileChunkSize || FileUtil.getChunkSize(filesize),
        options: options
      });
      this.queue.push(normalizedFile);
      this.startTaskWorker();
    }

    /**
     * Delete file from OSS
     */
  }, {
    key: "delete",
    value: (function () {
      var _delete2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(objectId, options) {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", this.httpService.deleteFile(objectId, options));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function _delete(_x, _x2) {
        return _delete2.apply(this, arguments);
      }
      return _delete;
    }()
    /**
     * Run specific worker task
     */
    )
  }, {
    key: "runTask",
    value: (function () {
      var _runTask = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(task) {
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.consumeWorker();
              _context2.next = 3;
              return task();
            case 3:
              this.releaseWorker();
              this.startTaskWorker();
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function runTask(_x3) {
        return _runTask.apply(this, arguments);
      }
      return runTask;
    }()
    /**
     * Start worker
     */
    )
  }, {
    key: "startTaskWorker",
    value: function startTaskWorker() {
      if (!this.hasAvailableWorker()) {
        return;
      }
      var task = TaskUtil.getWorkerTask({
        queue: this.queue,
        httpService: this.httpService,
        onUpdateStatus: this.updateQueue.bind(this)
      });
      if (!task) {
        return;
      }
      this.runTask(task);
      this.startTaskWorker(); // start next task worker in parallel
    }
  }]);
}();
var _default = exports["default"] = Oss;